var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6819 11.7697C16.7963 12.4131 16.7963 14.0218 15.6819 14.6652L7.53216 19.3704C6.41767 20.0139 5.02456 19.2096 5.02456 17.9227L5.02456 8.51222C5.02456 7.22532 6.41767 6.42101 7.53216 7.06446L15.6819 11.7697Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1895,
    y: 6.87518,
    width: 2.66394,
    height: 13.2571,
    rx: 1.33197,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForward);
export default __webpack_public_path__ + "static/media/ic_forward.4d4d2a32617ebaabc09afbf68efec9f2.svg";
export { ForwardRef as ReactComponent };